import { timeZones } from 'common/components/entities/Calendar/constants'

export const getLocalTimeZone = () => {
  const tz = Intl.DateTimeFormat().resolvedOptions().timeZone
  return timeZones.includes(tz) ? tz : 'UTC'
}
